import { postData } from 'helpers/RequestHelper';

export const recaptchaV2 = (captchaV2Success, captchaV2Failure) => {
  window.grecaptcha.render('recaptcha-v2', {
    sitekey: window.AppConfigState.google_recaptcha.site_key_v2,
    callback: captchaV2Success,
    'error-callback': captchaV2Failure
  });
  window.postHeapAnalytic('track', '[view][login][puzzle-captcha]');
};

export const validateRecaptchaV2 = async (token, email = '') => {
  const recaptchaValidationResponse = await postData({
    url: '/api/v1/google_recaptcha/verify',
    body: {
      heap_event_name: '[submit][login][attempt]',
      'g-recaptcha-response': token,
      google_recaptcha_token: token,
      user: { email }
    }
  });
  return recaptchaValidationResponse;
};

export const showRecaptchaError = () => {
  window.toastr.error(
    'Please complete the steps below to continue.',
    "We didn't recognize your device."
  );
};

export const submitRecaptchaForm = async (executeRecaptcha, email = '') => {
  if (window.AppConfig.state.google_recaptcha?.disabled) {
    return { human: true };
  }
  let recaptchaToken;
  if (!executeRecaptcha) {
    return { success: false };
  }
  try {
    recaptchaToken = await executeRecaptcha('authenticate');
  } catch (error) {
    return { success: false };
  }
  const recaptchaValidationResponse = await postData({
    url: '/api/v1/google_recaptcha/verify',
    body: {
      heap_event_name: '[submit][login][attempt]',
      google_recaptcha_token: recaptchaToken,
      user: { email }
    }
  });
  if (recaptchaValidationResponse?.data?.is_human === true) {
    return { human: true, recaptchaToken };
  }
  return { success: false };
};
